module.exports = __webpack_public_path__ + "static/hope-and-main-f043ee7bfbac6dab8c373f23230e60c3.png";